import { SxProps, Theme, ToggleButtonGroup, ToggleButtonGroupProps } from "@mui/material";
import { ReactNode } from "react";
import { StoneXLabeledItem } from "..";

interface StoneXToggleGroupProps extends ToggleButtonGroupProps {
    label?: ReactNode;
    /** MUI uppercases ToggleButton text by default; opt out without restyling every group in the app. */
    disableTextTransform?: boolean;
}

export function StoneXToggleButtonGroup(props: StoneXToggleGroupProps) {

    const { label, disableTextTransform, sx, children, ...toggleButtonGroupProps } = props;

    const mergedSx: SxProps<Theme> | undefined = disableTextTransform
        ? [{ '& .MuiToggleButton-root': { textTransform: 'none' } }, ...(Array.isArray(sx) ? sx : [sx])]
        : sx;

    return <StoneXLabeledItem label={label}>
        <ToggleButtonGroup {...toggleButtonGroupProps} sx={mergedSx}>
            {children}
        </ToggleButtonGroup>
    </StoneXLabeledItem>
}